/** Move item from → to and return a new array. */
export function moveItem<T>(list: T[], from: number, to: number): T[] {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= list.length ||
    to >= list.length
  ) {
    return list;
  }
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

/** Assign sequential sortOrder (0..n-1) for API payloads. */
export function withSortOrder<T extends { sortOrder?: number }>(
  items: T[],
): T[] {
  return items.map((item, i) => ({ ...item, sortOrder: i }));
}
